import React from "react";
import PropTypes from "prop-types";

import styles from "./NewsletterPromoSuccess.css";

export default class NewsletterPromoSuccess extends React.Component {
  constructor() {
    super();

    this.ref = React.createRef();
  }

  componentDidMount() {
    this.ref.current.focus();
  }

  render() {
    return (
      <div className={styles.root} ref={this.ref} tabIndex="-1">
        <div className={styles.big}>1 quick thing:</div>
        <span className={styles.small}>
          Check your email to confirm your subscription
        </span>
      </div>
    );
  }
}
